import { render, staticRenderFns } from "./TransactionsLoading.vue?vue&type=template&id=a2369252&scoped=true&"
import script from "./TransactionsLoading.vue?vue&type=script&lang=js&"
export * from "./TransactionsLoading.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsLoading.vue?vue&type=style&index=0&id=a2369252&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2369252",
  null
  
)

export default component.exports